const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

/**
 * Format a number for display as currency.
 * Fix to 2 decimal places and prepend '$'.
 * If null, return null.
 * @param value - A number representing a dollar amount.
 * @returns A stringified value in this format: $10.12
 */
export function formatAsCurrency(value?: number | null) {
  if (value == null) {
    return null
  }
  // fix to 2 decimal places and format with thousands separators
  return usdFormatter.format(value)
}
